import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { SettingService } from 'src/app/shared/services/setting.service';
import { AllergenNutritionFlavorService, IFindFlavor, IFlavor, IFlavorConfig } from '../../services/allergen-nutrition-flavor.service';
import { ModalController } from '@ionic/angular';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { IStore, StoreService } from 'src/app/store/services/store.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs';
import { ItemContentDetailsModalComponent } from 'src/app/shared/modals/item-content-details-modal/item-content-details-modal.component';

@Component({
  selector: 'app-flavors-page',
  templateUrl: './flavors-page.component.html',
  styleUrls: ['./flavors-page.component.scss'],
  standalone: false
})
export class FlavorsPageComponent  implements OnInit {

  stores: IStore[] = [];

  flavors: IFlavor;

  disableHeader: boolean = false;
  isPopup: boolean = false;
  mobile: boolean = false;

  findFlavor: IFindFlavor = {
    merchantId: "",
    deepSearch: false,
    itemIds: [],
    page: 0,
    pageSize: 0
  };

  viewNutrition: boolean = true;

  @ViewChildren('headerText') texts!: QueryList<ElementRef>;
  @ViewChildren('headerCell') cells!: QueryList<ElementRef>;

  selectedStore: IStore;
  isOpen: boolean = false;

  constructor(
    private allergenNutritionFlavorService: AllergenNutritionFlavorService,
    public settings: SettingService,
    private modalCtrl: ModalController,
    public translationService: TranslationService,
    private storeService: StoreService,
    private loaderService: LoaderService,
  ) { }

  ngOnInit() {
    this.getStores();
    this.getAllFlavors();

    if (window.innerWidth <= 500) {
      this.mobile = true;

      this.disableHeader = false;
    } else {
      this.mobile = false;

      this.disableHeader = true;
    }
  }

  ngAfterViewInit() {
    this.texts.forEach((text, i) => {
      const rect = text.nativeElement.getBoundingClientRect();
      const cell = this.cells.toArray()[i].nativeElement;

      cell.style.width = `${rect.width + 32}px`;
      cell.style.height = `${rect.height + 4}px`;
    });
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 

    if (window.innerWidth <= 500) { // follows the value of the modal
      this.mobile = true;

      this.disableHeader = false;
    } else {
      this.mobile = false;

      this.disableHeader = true;
    }
  }

  @HostListener('document:click')
  closeDropdown() {
    this.isOpen = false;
  }

  closePopup(){
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
  }

  selectStore(store?: IStore) {
    if(store) {
      this.selectedStore = store;
      this.isOpen = false;
    } else {
      this.selectedStore = null;
      this.isOpen = false;
    }
    
  }

  getAllFlavors(){
    this.fetchFlavors().subscribe(async flavors => {
      this.flavors = flavors;

      console.log(this.flavors);
    });
  }

  fetchFlavors() {

    this.findFlavor.merchantId = this.settings.getMerchantId();
    this.findFlavor.deepSearch = false;
    this.findFlavor.itemIds = [];
    this.findFlavor.page = 0;
    this.findFlavor.pageSize = 0;
    

    return this.allergenNutritionFlavorService.getFlavors(this.findFlavor);
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // store data processing

  async getStores() {
    console.log("collecting stores")
    const loader = await this.loaderService.create();

    this.storeService.getStores()
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe((data: IStore[]) => {
        //console.log(data);
        this.stores = data;

        console.log(this.stores);
      });
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // flavor data processing

  getItemFlavorName(itemId: string): string {
    const item = this.flavors.items.find(i => i.itemId === itemId);
    Math.floor
    return item.item.itemName.translations[this.translationService.getLanguage()];
  }

  getItemFlavorValue(itemId: string, flavor: IFlavorConfig): boolean {
    const itemData = flavor.itemValues.find(i => i.itemId === itemId);
    if(itemData) {
      return itemData.value;
    } else {
      return false; // default value if there's no fields for it from the db
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////

  async openItemContentDetails(contentType: string, itemId: string) {
    const modal = await this.modalCtrl.create({
      component: ItemContentDetailsModalComponent,
      componentProps: {
        contentDisplayType: contentType, // here it could be "all, nutrition, allergen and flavor"
        ItemId: itemId
      },
      cssClass: 'item-content-detail-modal-css'
    })

    modal.onWillDismiss()
    .then(async (result) => {
      if (result.data) { 
        
      }
    });

    await modal.present();
  }

}
